module.exports = __webpack_public_path__ + "static/media/cnito_live_bg_tablet_xmas.0ad0f33a.svg";